import {
  IAuthTokens,
  TokenRefreshRequest,
  useAuthTokenInterceptor
} from "axios-jwt";
import Vue, { PluginObject } from 'vue';
import axios from 'axios';

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  (cfg) => {
    // Do something before request is sent
    return cfg;
  },
  (err) => {
    // Do something with request error
    return Promise.reject(err);
  },
);

// Add a response interceptor
_axios.interceptors.response.use(
  (res) => {
    // Do something with response data
    return res;
  },
  (err) => {
    // Do something with response error
    return Promise.reject(err);
  },
);

// ============================================================================
// JWT section - START
// ============================================================================

export interface IAuthResponse {
  token: string;
  refresh_token: string;
}
const API_URL = process.env.VUE_APP_API_URL;
const REFRESH_TOKEN_PATH = process.env.VUE_APP_JWT_REFRESH_TOKEN_PATH;
const refreshEndpoint = `${API_URL}${REFRESH_TOKEN_PATH}`;

export const authResponseToAuthTokens = (res: IAuthResponse): IAuthTokens => ({
  accessToken: res.token,
  refreshToken: res.refresh_token
});

const requestRefresh: TokenRefreshRequest = async (
  refreshToken: string
): Promise<string> => {
  return (await axios.post(refreshEndpoint, { refresh_token: refreshToken }))
    .data
    .token;
};

useAuthTokenInterceptor(_axios, { requestRefresh });

// ============================================================================
// JWT section - END
// ============================================================================

const Plugin: PluginObject<any> = {
  install: (Vue) => {
    Vue.$axios = _axios;
  },
};
Plugin.install = (Vue) => {
  Vue.$axios = _axios;
  Vue.$http = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    $axios: {
      get() {
        return _axios;
      },
    },
  });
  Object.defineProperties(Vue.prototype, {
    $http: {
      get() {
        return _axios;
      },
    },
  });
};

Vue.use(Plugin);

export default Plugin;
